/** Literal value that enables script data-attribute auth resolution. */
const DATA_ATTRIBUTES_ENABLED = 'true'

export interface SilentSsoAuthConfigInput {
	clientId: string | null | undefined
	authority: string | null | undefined
	useDataAttributes: string | null
	country: string | null
	language: string | null
	environment: string | null
}

function isNonEmpty(value: string | null | undefined): boolean {
	return Boolean(value?.trim())
}

/**
 * Whether MSAL ssoSilent is safe to attempt for the current host config.
 *
 * Silent SSO is skipped when clientId or authority is missing (e.g. static-map DEFAULT fallback),
 * or when data-attribute mode is on but country / language / environment companions are incomplete.
 * NavConfig hosts (data attributes off) only need a non-empty clientId and authority.
 */
export function isSilentSsoAuthConfigComplete(input: SilentSsoAuthConfigInput): boolean {
	if (!isNonEmpty(input.clientId) || !isNonEmpty(input.authority)) {
		return false
	}

	if (input.useDataAttributes === DATA_ATTRIBUTES_ENABLED) {
		return isNonEmpty(input.country) && isNonEmpty(input.language) && isNonEmpty(input.environment)
	}

	return true
}
